import BaseModel from '@core/model';

export class Sector extends BaseModel {
    static entity = 'sectors';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default Sector;
